/*!
 * Copyright (C) Microsoft Corporation. All rights reserved.
 */
import { styled } from '@fluentui/react/lib/Utilities';
import { FormulaEditorBase } from './FormulaEditor.base';
import { getStyles } from './FormulaEditor.styles';
export var FormulaEditor = styled(FormulaEditorBase, getStyles);
//# sourceMappingURL=FormulaEditor.js.map